import { createAction } from 'Utility/Redux';
import { PlatformErrorCode } from '@sgorg/mobile-dev-tools';
import { signIn, signOutFirebase } from './Action/SignIn';
import { SignInState } from './SignInState';
import { handleBackPress } from 'State/Game/Action/HandleBackPress';

export enum PlatformActionType {
    SET_SIGN_IN_STATE = 'setSignInState',
    SIGN_OUT_PROMPT = 'signOutPrompt',
    SIGN_IN_FAIL = 'signInFail',
    SIGN_IN_SILENT_FAIL = 'signInSilentFail',
    SIGN_IN_SUCCESS = 'signInSuccess',
    SCHEDULE_NOTIFICATION = 'scheduleNotification',
    SHOW_QUIT_MENU = 'showQuitMenu',
    QUIT_GAME = 'quitGame',
    CANCEL_FIREBASE_SIGN_OUT = 'cancelFirebaseSignOut',
    SET_SIGN_IN_FACEBOOK_REWARD = 'setSignInFacebookReward',
    SET_FACEBOOK_UNIFIED = 'setFacebookUnified',
}

export const PlatformActions = {
    signIn: signIn,
    signOutFirebase: signOutFirebase,
    handleBackPress,
    signOutPrompt: createAction(PlatformActionType.SIGN_OUT_PROMPT),
    setSignInState: createAction(PlatformActionType.SET_SIGN_IN_STATE, resolve => (state: SignInState) =>
        resolve<SignInState>(state)
    ),
    /**
     * Prompt the user with an error message based on the error code received.
     */
    signInFail: createAction(
        PlatformActionType.SIGN_IN_FAIL,
        resolve => (errorCode: PlatformErrorCode = PlatformErrorCode.UNKNOWN) => resolve<PlatformErrorCode>(errorCode)
    ),
    /**
     * "Silent" fail - do not show an error message to the user.
     */
    signInSilentFail: createAction(PlatformActionType.SIGN_IN_SILENT_FAIL),
    signInSuccess: createAction(PlatformActionType.SIGN_IN_SUCCESS),
    showQuitMenu: createAction(PlatformActionType.SHOW_QUIT_MENU),
    quitGame: createAction(PlatformActionType.QUIT_GAME),
    cancelFirebaseSignOut: createAction(PlatformActionType.CANCEL_FIREBASE_SIGN_OUT),
    setSignInFacebookReward: createAction(PlatformActionType.SET_SIGN_IN_FACEBOOK_REWARD),
    setFacebookUnified: createAction(PlatformActionType.SET_FACEBOOK_UNIFIED)
};
